import React from 'react'
import Select from "react-select";
import makeAnimated from 'react-select/animated';


const animatedComponents = makeAnimated();



export const SelectElement = ({
  options = [],
  value,
  onChange,
  isMulti = false,
  closeOnMenuSelect = true,
  className,
  isClearable = true,
  placeholder = "Seleccione",
  fontSize = "12px" }) => {

  // const [optionSelected, setSelectedOptions] = useState('');

  const handleChange = (selected) => {
    if (isMulti) {
      onChange(selected || []);
    } else {
      onChange(selected || null);
    }
  };




  return (
    <Select
      options={options}
      value={value}
      isMulti={isMulti}
      isSearchable
      isClearable={isClearable}
      closeMenuOnSelect={closeOnMenuSelect}
      onChange={handleChange}
      placeholder={placeholder}
      noOptionsMessage={() => "No hay resultados"}
      components={animatedComponents}
      className={className}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      styles={{
        control: (base) => ({
          ...base,
          fontSize,
          minHeight: "auto"
        }),
        singleValue: (base) => ({ ...base, fontSize }),
        input: (base) => ({ ...base, fontSize }),
        placeholder: (base) => ({ ...base, fontSize }),
        option: (base) => ({
          ...base,
          fontSize,
          padding: "10px 15px"
        }),
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999
        })
      }}
    />
  );
}
